let config = {
  BLANK_LINK: "#!",
  STATE: [
    { id: "NSW", name: "NSW" },
    { id: "QLD", name: "QLD" },
    { id: "SA", name: "SA" },
    { id: "TAS", name: "TAS" },
    { id: "VIC", name: "VIC" },
    { id: "WA", name: "WA" },
    { id: "ACT", name: "ACT" },
    { id: "NT", name: "NT" },
  ],
}

export default config
